/* eslint-disable eqeqeq */
import React, { useState, useEffect, Fragment, useMemo } from 'react';
import { withRouter } from 'react-router-dom';
import {
  Dropdown, Table, Tag, Drawer, Popover, Popconfirm, Divider
} from 'antd';
import { FilterOutlined, EditOutlined } from '@ant-design/icons';
import { connect } from 'react-redux';
import Helpers from '@Apis/helpers';
import { toISTDate, entityNameEnum, filterTypeEnums } from '@Apis/constants';
import H3Text from '@Uilib/h3Text';
import searchIcon from '@Images/icons/icon-search.png';
import H3Image from '@Uilib/h3Image';
import H3Button, { defaultButtonTypes } from '@Uilib/h3Button';
import closeIcon from '@Images/icons/icon-close-blue.png';
import TenantSelector from '@Components/Common/Selector/TenantSelector';
import StockMasterActions from '@Actions/inventory/stockMasterActions';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPen, faTrash, faTrashCan } from '@fortawesome/free-solid-svg-icons';
import ProductListForm from './ProductListForm';
import PRZButton from '../../../Common/UI/PRZButton';
import PRZText from '../../../Common/UI/PRZText';
import useCheckPortrait from '../../../../hooks/useCheckPortrait';
import './style.scss';
import UserSavedFilterViewSelector from '../../../Common/UserSavedFilterViewSelector';

const ProductList = ({
  user,
  history,
  getProductList,
  productLists,
  getProductListLoading,
  updateProductList,
  updateProductListLoading,
}) => {
  const [searchKeyword, setSearchKeyword] = useState('');
  const [keyword, setKeyword] = useState('');
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [selectedTenant, setSelectedTenant] = useState([]);
  const [call, setCall] = useState(false);
  const [showAddProductListModal, setShowAddProductListModal] = useState(false);
  const [showViewProductListModal, setShowViewProductListModal] = useState(false);
  const [productListId, setProductListId] = useState('');
  const [isUserReady, setIsUserReady] = useState(false);
  // states related to saved filters
  const [currentDefaultView, setCurrentDefaultView] = useState({});
  const [currentlyAppliedFilters, setCurrentlyAppliedFilters] = useState([]);
  const [selectedFilterView, setSelectedFilterView] = useState({});
  const [isUserReadyInitial, setIsUserReadyInitial] = useState(false);
  const [isUpdateFilterSate, setIsUpdateFilterSate] = useState(true);
  const [savedFilterViews, setSavedFilterViews] = useState([]);
  const [savedFilterViewsLoading, setSavedFilterViewsLoading] = useState(false);

  const {
    isMobile, isPortrait, isMobileAndPortrait, isMobileOrPortrait,
  } = useCheckPortrait();

  const productListColumns = () => {
    const columns = [
      {
        title: '',
        render: (record) => {
          return (
            <div className="mobile-list__card">
              <div className="mobile-list__card_body">
                <div className="mobile-list__card_body-left">

                  <div className="mobile-list__card_item-name_wrapper">
                    <PRZText className="mobile-list__card_item-name" text={`${record?.list_name}`} />
                  </div>
                  <PRZText
                    text={`Description - ${record?.list_description}`}
                    className="mobile-list__card_item-details"
                  />

                  <PRZText
                    text={`Location - ${record?.tenant_info?.find(
                      (item) => item.tenant_id === user.tenant_info.tenant_id,
                    )?.tenant_name || record?.tenant_info[0]?.tenant_name}`}
                    className="mobile-list__card_item-details"
                  />

                  {record?.tenant_info?.length > 1 && (
                    <Popover
                      position="right"
                      content={(
                        <div
                          style={{
                            maxHeight: '85px',
                            overflowY: 'auto',
                            width: '150px',
                          }}
                        >
                          {record?.tenant_info?.map((item) => (
                            <div
                              key={item?.tenant_name}
                              style={{
                                fontSize: '11px',
                              }}
                            >
                              {item?.tenant_name.toProperCase()}
                            </div>
                          ))}
                        </div>
                      )}
                      trigger={['click']}
                    >
                      <div
                        className="table-subscript tenant-info"
                        style={{
                          width: 'fit-content',
                        }}
                      >
                        {`and ${record?.tenant_info?.length - 1} others`}
                      </div>
                    </Popover>
                  )}

                </div>
                <div className="mobile-list__card_body-right">
                  {record?.product_type?.toUpperCase() !== 'SERVICE' && (
                    <Popover
                      color="white"
                      placement="top"
                      title={(
                        <PRZText className="mobile-list__card_item__tooltip_text-color" text="Number of Products" />
                      )}
                      trigger={['click']}
                    >
                      <PRZText
                        text={record?.products_count}
                        className="mobile-list__card_item-details"
                      />
                    </Popover>
                  )}
                </div>
              </div>
            </div>
          );
        },
        // responsive: ['xs'],
        hidden: !isMobile,
      },
      {
        title: 'List Name',
        render: (record) => (
          <div className="column-number__wrapper max-250 min-width-100">
            {record?.list_name}
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
      },
      {
        title: 'Description',
        render: (record) => (
          <div className="max-250 min-width-85">
            {record?.list_description}
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
      },
      {
        title: 'Products',
        render: (record) => <div className="min-width-70">{record?.products_count}</div>,
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
      },
      {
        title: 'Locations',
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        render: (text, record) => (
          <div className="min-width-70">
            <H3Text
              text={
                record?.tenant_info?.find(
                  (item) => item.tenant_id === user.tenant_info.tenant_id,
                )?.tenant_name || record?.tenant_info[0]?.tenant_name
              }
            />
            {record?.tenant_info?.length > 1 && (
              <Popover
                position="right"
                content={(
                  <div
                    style={{
                      maxHeight: '85px',
                      overflowY: 'auto',
                      width: '150px',
                    }}
                  >
                    {record?.tenant_info?.map((item) => (
                      <div key={item?.tenant_name}>
                        <span>{item?.tenant_name.toProperCase()}</span>
                      </div>
                    ))}
                  </div>
                )}
              >
                <div
                  className="table-subscript tenant-info"
                >
                  {`and ${record?.tenant_info?.length - 1} others`}
                </div>
              </Popover>
            )}
          </div>
        ),
      },
      {
        title: 'Last Updated',
        render: (record) => (
          <div className="min-width-100">
            {record?.updated_at
              ? (
                <div className="column-date">
                  {toISTDate(record?.updated_at).format('DD/MM/YYYY hh:mm A')}
                </div>
              )
              : '-'}
            <H3Text
              text={
                record?.modified_by_info
                  ? `${record?.modified_by_info.first_name} ${record?.modified_by_info.last_name}`
                  : ''
              }
              className="table-subscript"
            />
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
      },
      {
        title: '',
        key: 'action',
        render: (record) => (
          <div className="list__actions">
            <Popconfirm
              title="Are you sure you want to delete this item?"
              description="This is a irreversible action and you will not be able to recover this product group."
              placement="topRight"
              onConfirm={() => {
                updateProductList(
                  {
                    sku_list_id: record?.sku_list_id,
                    is_archived: true,
                  },
                  () => setCall(!call),
                );
              }}
            >
              <div className="list__actions-button list__actions-button-delete">
                <FontAwesomeIcon icon={faTrash} />
              </div>
            </Popconfirm>

            {Helpers.getPermission(
              Helpers.permissionEntities.PRODUCT,
              Helpers.permissionTypes.UPDATE,
              user,
            ) && (
                <div
                  className="list__actions-button"
                  onClick={() => {
                    setProductListId(record?.sku_list_id);
                    setShowAddProductListModal(true);
                  }}
                >
                  <FontAwesomeIcon icon={faPen} />
                </div>
              )}
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        fixed: 'right',
        className: 'list__actions-column',
      },
    ];

    return columns.filter((item) => !item.hidden);
  };
  const pushParamsToUrl = (currentPage, currentLimit, currentTenant, word, selectedFilterView) => {
    let url = '?tab=/product-groups';
    if (currentPage) url += `&page=${currentPage}`;
    if (currentLimit) url += `&limit=${currentLimit}`;
    if (word) url += `&keyword=${word}`;
    if (currentTenant) url += `&tenant=${currentTenant}`;
    if (selectedFilterView?.filter_id) url += `&filter_id=${selectedFilterView?.filter_id}`;
    history.push(url);
  };

  // common 
  function getFilterValueByKey({ filtersArray, key, valueOnly = true }) {
    const selectedFilter = filtersArray.find((item) => item.filter_key === key) || null;
    return valueOnly ? selectedFilter?.filter_value : selectedFilter;
  }

  function getAppliedFiltersFromURL() {
    const appliedFiltersFromURL = [
      {
        filter_key: 'keyword',
        filter_value: Helpers.getValueFromUrl('keyword') || '',
        filter_type: filterTypeEnums.STRING,
      },
      {
        filter_key: 'limit',
        filter_value: Number(Helpers.getValueFromUrl('limit') || limit),
        filter_type: filterTypeEnums.NUMBER,
      },
      {
        filter_key: 'tenant',
        filter_value: Helpers.getValueFromUrl('tenant') ? Helpers.getValueFromUrl('tenant')?.split(',')?.map((item) => Number(item)) : [],
        filter_type: filterTypeEnums.ARRAY,
      },
    ];
    return appliedFiltersFromURL;
  }

  const initialFilterValues = useMemo(() => [
    {
      filter_key: 'keyword',
      filter_value: '',
      filter_type: filterTypeEnums.STRING,
    },
    {
      filter_key: 'limit',
      filter_value: limit,
      filter_type: filterTypeEnums.NUMBER,
    },
    {
      filter_key: 'tenant',
      filter_value: [user?.tenant_info?.tenant_id],
      filter_type: filterTypeEnums.ARRAY,
    },
  ], []);
  const systemDefaultUserView = useMemo(() => ({
    filter_id: 'system_default',
    filter_name: 'System Default View',
    entity_name: entityNameEnum.PRODUCT_GROUP,
    filters: initialFilterValues,
    tenant_id: user?.tenant_info?.tenant_id,
    org_id: user?.user_org_id,
    user_id: user?.user_id,
    is_default: false,
    is_system_default: true,
  }), []);

  useEffect(() => {
    setSelectedFilterView(systemDefaultUserView);
  }, []);
  // useEffect(() => {
  //   if (user?.tenant_info?.org_id) {
  //     setSearchKeyword(Helpers.getValueFromUrl('keyword'));
  //     setPage(Number(Helpers.getValueFromUrl('page') || page));
  //     setSelectedTenant(
  //       Helpers.getValueFromUrl('tenant')
  //         ? Helpers.getValueFromUrl('tenant')
  //           ?.split(',')
  //           ?.map((item) => Number(item))
  //         : [user?.tenant_info?.tenant_id],
  //     );
  //     setIsUserReady(true);
  //   }
  // }, []);
  useEffect(() => {
    if (savedFilterViews && isUserReadyInitial) {
      const defaultUserView = savedFilterViews.find((item) => item.is_default);

      if (defaultUserView) {
        setCurrentDefaultView(defaultUserView);
      } else {
        setCurrentDefaultView(systemDefaultUserView);
      }

      const appliedFiltersFromURL = getAppliedFiltersFromURL();

      const selectedFilterViewFromURL = Helpers.getValueFromUrl('filter_id');
      let currentSelectedView;
      if (selectedFilterViewFromURL) {
        currentSelectedView = savedFilterViews.find((item) => String(item.filter_id) === String(selectedFilterViewFromURL));
        if (!currentSelectedView) {
          currentSelectedView = systemDefaultUserView;
        }
      } else {
        currentSelectedView = defaultUserView || systemDefaultUserView;
      }

      const filterValues = (isFromURL) => {
        const currentSelectedViewFilters = currentSelectedView.filters;

        const filterValue = initialFilterValues.map((item) => item.filter_key).reduce((acc, filterKey) => ({ ...acc, [filterKey]: getFilterValueByKey({ filtersArray: isFromURL ? appliedFiltersFromURL : currentSelectedViewFilters, key: filterKey }) }), {});

        return filterValue;
      };

      const tempFilterValues = filterValues(selectedFilterViewFromURL);
      setSelectedFilterView(currentSelectedView);
      if (isUpdateFilterSate) {
        // common state
        setCurrentlyAppliedFilters(appliedFiltersFromURL);
        // temp state
        setPage(tempFilterValues.page || 1);
        setLimit(tempFilterValues.limit || limit);
        setSearchKeyword(tempFilterValues.keyword);
        setKeyword(tempFilterValues.keyword);
        setSelectedTenant(tempFilterValues.tenant);
      }

      if (!isUserReady) setIsUserReady(true);
      if (!isUpdateFilterSate) setIsUpdateFilterSate(true);
    }
  }, [savedFilterViews, isUserReadyInitial]);



  useEffect(() => {
    if (isUserReady) {
      pushParamsToUrl(page, limit, selectedTenant, keyword, selectedFilterView);
      setCurrentlyAppliedFilters(getAppliedFiltersFromURL());
      getProductList({
        tenantId:
          selectedTenant?.filter((item) => !isNaN(item))?.length > 0
            ? selectedTenant?.join(',')
            : Helpers.getTenantEntityPermission(
              user?.user_tenants,
              Helpers.permissionEntities.SALES_ORDER,
              Helpers.permissionTypes.READ,
            )?.join(','),
        keyword: Helpers.getValueFromUrl('keyword'),
        page: Helpers.getValueFromUrl('page'),
        limit: Helpers.getValueFromUrl('limit'),
      });
    }
  }, [selectedTenant, keyword, page, limit, call]);

  return (
    <Fragment>
      <div className="doc-list__wrapper doc-list__tab-content">
        <div className="ant-row">
          <div className="ant-col-xs-24">
            <div className="doc-list__header-wrapper">
              <div className="doc-list__header-wrapper__left">
                <div className="section-search">
                  <div className="doc-list__search-bar__wrapper">
                    <div className="section-search-bar">
                      <input
                        value={searchKeyword}
                        placeholder="Search here..."
                        onKeyDown={(e) => {
                          if (e.key === 'Enter') {
                            setKeyword(e.target.value);
                            setPage(1);
                            setLimit(10);
                          }
                        }}
                        onChange={(event) => {
                          setSearchKeyword(event.target.value);
                          setPage(1);
                          setLimit(10);
                        }}
                      />
                      <H3Image
                        src={searchIcon}
                        className="section-search-bar__icon"
                        alt="search"
                        onClick={() => {
                          setKeyword(searchKeyword);
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="doc-list__header-wrapper__right">
                {Helpers.getPermission(
                  Helpers.permissionEntities.PRICE_LIST,
                  Helpers.permissionTypes.CREATE,
                  user,
                ) && (
                    <div className="doc-list__buttons-wrapper">
                      <PRZButton
                        onClick={() => {
                          setShowAddProductListModal(true);
                        }}
                        className="add-button"
                      >
                        + Add Product Group
                      </PRZButton>
                    </div>
                  )}
              </div>
            </div>
            <div className="flex-align-c" style={{ gap: '10px' }}>
              <UserSavedFilterViewSelector
                selectedFilterView={selectedFilterView}
                onChangeTab={(currentSelectedView) => {
                  setSelectedFilterView(() => {
                    const currentSelectedViewFilters = currentSelectedView.filters;

                    const filterValue = initialFilterValues.map((item) => item.filter_key).reduce((acc, filterKey) => ({ ...acc, [filterKey]: getFilterValueByKey({ filtersArray: currentSelectedViewFilters, key: filterKey }) }), {});

                    const tempFilterValues = filterValue;
                    // common state
                    setCurrentlyAppliedFilters(currentSelectedViewFilters);
                    // temp states
                    setPage(tempFilterValues.page || 1);
                    setLimit(tempFilterValues.limit || limit);
                    setSearchKeyword(tempFilterValues.keyword);
                    setKeyword(tempFilterValues.keyword);
                    setSelectedTenant(tempFilterValues.tenant);
                    return currentSelectedView;
                  });
                }}
                currentlyAppliedFilters={currentlyAppliedFilters}
                entityName={entityNameEnum.PRODUCT_GROUP}
                setSavedFilterViews={(value) => setSavedFilterViews(value)}
                setSavedFilterViewsLoading={(value) => setSavedFilterViewsLoading(value)}
                setIsUpdateFilterSate={(value) => setIsUpdateFilterSate(value)}
                callback={() => {
                  if (!isUserReadyInitial) setIsUserReadyInitial(true);
                }}
                systemDefaultUserView={systemDefaultUserView}
              />
              <div className="header__tags">
                {keyword && (
                  <Tag
                    closable
                    onClose={() => {
                      setSearchKeyword('');
                      setKeyword(''); setPage(1);
                    }}
                    color="#2d7df7"
                  >
                    Search for &nbsp;
                    <span>
                      <b>{keyword}</b>
                    </span>
                  </Tag>
                )}
                {selectedTenant
                  && selectedTenant?.map((item) => (
                    <Tag
                      key={item}
                      closable
                      onClose={() => {
                        setPage(1);
                        setSelectedTenant(
                          selectedTenant?.filter((tId) => tId !== item),
                        );
                      }}
                      color="#2d7df7"
                    >
                      Business Unit - &nbsp;
                      <span>
                        <b>
                          {user?.user_tenants
                            ?.find((tenant) => tenant?.tenant_id == item)
                            ?.tenant_name?.toUpperCase()}
                        </b>
                      </span>
                    </Tag>
                  ))}
              </div>
            </div>
            {user && (
              <div className="doc-list__table-wrapper">
                <Table
                  title={() => (
                    <div className="doc-list__table-header">
                      <div className="doc-list__table-header__left">
                        <H3Text
                          text={`${productLists?.count ?? 0} Product List`}
                          className=""
                        />
                      </div>
                      <div className="doc-list__table-header__right">
                        <Dropdown
                          trigger={['click']}
                          placement='bottom'
                          overlay={(
                            <div className="header__filter__container">
                              <div className="header__filter__container__title">
                                Apply Filters
                              </div>
                              <div className="filter__container filter__container-section">
                                <div className="filter__title">
                                  {' '}
                                  Select Business Unit{' '}
                                </div>
                                <TenantSelector
                                  selectedTenant={selectedTenant}
                                  showSearch
                                  showAll={false}
                                  noDropdownAlign
                                  isMultiple
                                  onChange={(value) => {
                                    setPage(1);
                                    setSelectedTenant(value);
                                  }}
                                  placeholder="Select Business Unit"
                                  inputClassName="orgInputContainer"
                                  hideTitle
                                  includedTenants={Helpers.getTenantEntityPermission(
                                    user?.user_tenants,
                                    Helpers.permissionEntities
                                      .PURCHASE_REQUEST,
                                    Helpers.permissionTypes.READ,
                                  )}
                                />
                              </div>
                            </div>
                          )}
                        >
                          <div className="doc-list__action-buttons">
                            <div className="action-button">
                              <H3Text
                                text="Filters"
                                className="action-button-text"
                              />
                              <FilterOutlined />
                            </div>
                          </div>
                        </Dropdown>
                      </div>
                    </div>
                  )}
                  loading={getProductListLoading || updateProductListLoading}
                  showHeader
                  size="small"
                  scroll={!isMobileOrPortrait && !!productLists?.sku_lists?.length ? { x: 'max-content', y: 'calc(100dvh - 100px)' } : { x: 'max-content' }}
                  sticky={!isMobileOrPortrait && !!productLists?.sku_lists?.length}
                  columns={productListColumns()}
                  dataSource={productLists?.sku_lists || []}
                  bordered
                  pagination={
                    {
                      defaultCurrent: page,
                      current: page,
                      total: productLists?.count ?? 0,
                      pageSize: limit,
                      position: ['bottomLeft'],
                      showSizeChanger: true,
                      pageSizeOptions: [10, 25, 50, 100],
                      showTotal: (tot, range) => `${range[0]}-${range[1]} of ${tot} items`,
                      onChange: (page, pageSize) => {
                        setPage(page);
                        setLimit(pageSize);
                        setCall(!call);
                      },
                    }
                  }
                />
              </div>
            )}
          </div>
        </div>
      </div>
      <Drawer
        open={showAddProductListModal}
        width="840px"
        mask
        onClose={() => {
          setShowAddProductListModal(false);
          setProductListId(null);
        }}
        destroyOnClose
      >
        <div className="custom-drawer__header-wrapper">
          <div className="custom-drawer__header" style={{ width: '790px' }}>
            <H3Text
              text={`${productListId ? 'Update Product Group' : 'Create Product Group'
                }`}
              className="custom-drawer__title"
            />
            <H3Image
              src={closeIcon}
              className="custom-drawer__close-icon"
              onClick={() => {
                setShowAddProductListModal(false);
                setProductListId(null);
                setCall(!call);
              }}
            />
          </div>
        </div>
        <ProductListForm
          callback={() => {
            setShowAddProductListModal(false);
            setCall(!call);
          }}
          productListId={productListId}
        />
      </Drawer>
    </Fragment>
  );
};

const mapStateToProps = ({ UserReducers, StockMasterReducers }) => ({
  user: UserReducers.user,
  productLists: StockMasterReducers.productLists,
  getProductListLoading: StockMasterReducers.getProductListLoading,
  updateProductListLoading: StockMasterReducers.updateProductListLoading,
});

const mapDispatchToProps = (dispatch) => ({
  getProductList: (payload, callback) =>
    dispatch(StockMasterActions.getProductList(payload, callback)),
  updateProductList: (paylaod, callback) =>
    dispatch(StockMasterActions.updateProductList(paylaod, callback)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withRouter(ProductList));
